export default __webpack_public_path__ + "static/media/gift-box-pharmatching.8f5ccda7.svg";